import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'states/store';

export const select = (state: RootState) => state.dataPartner;

export const selectStatus = createSelector(select, (state) => state.status);
